import "./Capabilities.css";
import Footer from "./Footer";

import cap from "../assets/cap.jpg";
import rndImg from "../assets/rnd.png";
import manufacturingImg from "../assets/manufacturing.png";
import qualityImg from "../assets/quality.png";

const cards = [
  {
    title: "Research & Development",
    title1: "Product Development & Innovation",
    desc: "Our R&D capabilities span product design, VAVE, lightweighting, simulation, prototyping and process innovation, taking concepts from development through validation.",
    link: "/capabilities/cap-research",
    img: rndImg,
  },
  {
    title: "Manufacturing",
    title1: "Integrated & Lean Production",
    desc: "End-to-end casting, heat treatment and precision machining under one roof — delivering stable quality from prototype to volume.",
    link: "/capabilities/cap-manufacture",
    img: manufacturingImg,
  },
  {
    title: "Quality",
    title1: "Built-In Assurance",
    desc: "Quality engineered into every stage through robust systems, real-time controls and global automotive standards.",
    link: "/capabilities/cap-quality",
    img: qualityImg,
  },
];

export default function Capabilities() {
  return (
    <section id="cap">

      {/* TOP SECTION */}
      <div className="capability-wrapper">

        {/* LEFT CONTENT */}
        <div className="capability-text">
          <h3>Capabilities</h3>

          <h3>
            Engineering Excellence Across the Value Chain
          </h3>

          <p>
            At Sundaram Clayton Limited (SCL), our capabilities span the
            complete aluminium component lifecycle — from advanced R&D and
            integrated manufacturing to world-class quality systems. Together,
            they enable lightweight, high-performance solutions delivered with
            consistency, speed and global reliability.
          </p>
        </div>

        {/* RIGHT IMAGE */}
        <div className="capability-image">
          <img src={cap} alt="Capabilities" />
        </div>
      </div>

      {/* SECTION TITLE */}
      <h2 className="capability-title">
        What We Offer
      </h2>

      <div className="cap-underline"></div>

      {/* CAPABILITY CARDS */}
      <div className="cap-cards">

        {cards.map((card, index) => (
          <div
            className="cap-card2"
            key={index}
          >

            {/* IMAGE / PLACEHOLDER */}
            <div className={`cap-image ${index === 0 ? "cap-image-contain" : ""}`}>
              {card.img && (
                <img
                  src={card.img}
                  alt={card.title}
                />
              )}
            </div>

            {/* CARD TITLE */}
            <h3>
              {card.title}
            </h3>

            {/* CARD SUB TITLE */}
            <h4>
              {card.title1}
            </h4>

            {/* CARD DESCRIPTION */}
            <p>
              {card.desc}
            </p>

            {/* EXPLORE LINK */}
            <a
              href={card.link}
              className="cap-offer-link"
            >
              <span>
                Explore ↗
              </span>
            </a>

          </div>
        ))}

      </div>

      {/* BOTTOM TEXT */}
      <p
        style={{
          textAlign: "center",
          margin: "30px 100px 60px 100px",
        }}
      >
        One ecosystem. End-to-end confidence.
      </p>

      {/* FOOTER */}
      <Footer />

    </section>
  );
}
